<template>
	<div>
		{{ texto }} <i class="fa fa-spinner fa-pulse fa-sm" aria-hidden="true"></i>
	</div>
</template>

<script setup>
import {defineProps} from 'vue';
defineProps({
	texto:String
})
</script>